import Price from "components/Price/Price"
import { Col, Row } from "elemental-react16"
import { Button, Card, Icon, Modal, Segment, Image, Message,Table,Tab, TabPane, Input, Dropdown } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import React, { Component, Fragment } from "react"
import shop from "shop/shop"
import _ from "lodash"
import moment from "moment"
import "moment/locale/de"
import CostCentres  from "components/CostCentres/CostCentres";
import AccountReset from "components/Account/AccountReset"
import swal from "sweetalert"
import OrderModel from "../../../shop/OrderModel";
import { Redirect } from "react-router"
import CartTotal from "components/Cart/CartTotal"
import Responsive from "react-responsive"
import ProductTable from "components/Product/ProductTableReadOnly"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import QuickorderTable from "components/Quickorder/QuickorderTable"
import ProductTableProducts        from "components/Product/ProductTable"
import MediaQuery from "react-responsive"
import ProductCount from "components/Product/ProductCount"
import htmr                                                                           from "htmr";
import {
  FormField,
  FormInput,
} from "elemental-react16"
import ProductPriceInquiry from "components/Product/ProductPriceInquiry"


let lastProducts = null

const setPasswordAsAdmin = ( account ) => {

  swal( {
      text            : "Passwort setzen",
      type            : "prompt",
      title           : "Neues Passwort",
      showCancelButton: true,
      closeOnConfirm  : false,
      closeOnCancel   : true,
    },
    newPassword => {
      if ( !newPassword ) return
      shop.fetch( `/shop/rest/security/user/${account.userid}/logins?passupdate=1`, {
        method: "POST",
        body  : JSON.stringify( {
          ...account,
          "password": newPassword,
          "newpass" : newPassword,
          "repeat"  : newPassword
        } )
      } )
        .then( res => {
          console.log( "PW CHANGE", res )
          swal( translate( "reset.success" ),
            translate( "Passwort erfolgreich gesetzt." ),
            "success" )
        } )
        .catch( err => {
          console.error( err )
          swal( "Fehler", "Leider konnte IhrPasswort nicht geändert werden", "error" )
        } )

    }
  )
}

export function fetchExtraOrderRessources( order ) {
  return shop.fetch( `/shop/rest/data/customer/current/extrainfo?start=0&count=50&subref=${order.map_id}` )
    .then( res => {
      order.extrainfo = res.map( data => new OrderPDF( data ) )
      return new OrderModel(order)
    } )
}


class Accounts extends React.Component {

  state = {
    loading : false,
    accounts: [],
    user: false,
  }

  async componentDidMount() {
    this.setState( { loading: true } )

    const users    = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22${shop.session.value.map_id}%22%7D`)

    var temp;
    if (users.length > 0) {
      this.user = users[0];
      temp = await shop.fetch( `/shop/rest/security/user/${users[0].id}/logins` )
    } else {
      temp = [];
    }

    const accounts = temp;
    console.log( { accounts } )
    this.setState( { accounts, loading: false } )
  }

  render() {
    const { accounts } = this.state
    return <div>
      <Segment.Group>
        {accounts.map( account => {
          return <Segment clearing key={account.login}>
            <Button floated={"right"} onClick={() => setPasswordAsAdmin( account )}>{translate( "change Password" )}</Button>
            <div className="pa2 b">{account.login} {account.contact}</div>
          </Segment>
        } )}
      </Segment.Group>
    </div>
  }
}

export const orderTypes = {
  0: "Order",
  1: "Delivery",
  2: "Invoice",
}

class OrderPDF {
  constructor( order ) {
    Object.assign( this, order )
    this.typeName = orderTypes[ order.type ] || "Unknown"
    this.url = `${shop.config.BASE}/shop/rest/data/customer/current/extraresources/` + encodeURIComponent(order.map_id)
  }
}

@observer
export default class AccountPage extends Component {

  state = {
    session        : shop.session || {}, locations: [],
    orders         : [],
    current        : 0,
    showAddressBook: false,
    noMoreOrders   : false,
    frachtkosten   : true,
    topseller      : {},
    productsById   : {},
    count          : 1,
    productTempId  : "",
    modaleOpen     : false,
    searchString: "",
    productSearch: [],
    productModels : [],
  }

  loadProduct( id ) {

		this.id = id
		productStore.get( id )
			.then( product => {
				console.log( "ProductPage::product", product )
				//product.count = this.state.count
				let inCart = shop.cart.productsById.get( product.map_id )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				 lastProducts = shop.analytics.lastProducts( 4 )
				  .filter( ( id ) => id !== product.map_id )
        product.count = this.state.count
				this.setState( {product: product, primaryImage: false} )
        console.log("product ADD",product, this.state.count)
        shop.cart.add( product )
        this.setState( { count: 1 } )
        shop.toast( `${product.count * product.unit_multi} Stück ${product.title} ${translate( "im Warenkorb" )}`, "info", false, "bottom" )
				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

  loadProductModels   = ( id ) => {
    this.id = id
    productStore.get( id )
      .then( product => {
        console.log( "ProductPage::product", product )
        //product.count = this.state.count
        let inCart = shop.cart.productsById.get( product.map_id )
        if ( inCart ) product.count = Number( inCart.count )
        shop.analytics.push( product.map_id )
        lastProducts = shop.analytics.lastProducts( 4 )
          .filter( ( id ) => id !== product.map_id )
        product.count = this.state.count
        this.setState( {product, primaryImage: false} )
        let productModels = this.state.productModels || {};
        productModels[product.map_id] = product;
        this.setState({ productModels });
        console.log("this.state.productModels", this.state.productModels  )
      } )
      .catch( error => {
        this.setState( {error} )
      } )
  }

  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }


  loadMore = () => {
    let { orders, current } = this.state
    let pageSize = 40
    let start = current
    current = current + pageSize
    this.setState( { loading: true } )
    console.log("shop.session.value.map_id",shop.session.value.map_id)
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0&filter=[{"field":"customerId","op":"equals","value":"${shop.session.value.map_id}"}]` )
      .then( async res => {
        let extras = res.values.map( order => fetchExtraOrderRessources( order ) )
        await Promise.all( extras )
        console.log( "FROM API", { res } )
        orders = orders.concat( res.values )
        this.setState( { loading: false, current, orders } )
        if ( res.values.length === 0 ) {
          this.setState( { noMoreOrders: true, current, orders } )
        }
      } )
  }
  loadTopseller = async () => {
    shop.fetch( `/shop/rest/data/topseller?count=1000&customer=${shop.session.value.map_id}`)
    .then( async response => {
      console.log("TOPSELLER RESP", response)
      response.value.forEach(product => {
        product.count = product.pinfos && product.pinfos.minbuy ? product.pinfos.minbuy : 1;
      });
      this.setState( { topseller: response.value, productSearch: response.value } )
      //console.log("TOPSELLER POST", this.state.topseller)
      let productsById = {}
      response.value.forEach( product => async () => {
        productsById[product.map_id] = product
        
      } )
      this.setState( { productsById } )
      //console.log("PRODUCTS BY ID", this.state.productsById)
    })

  }

  loadSession = ( session ) => {
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        this.setState( { locations } )
      } )
      this.loadTopseller()

  }

  handleChange = ( { product } ) => {
    let list = shop.orderlist.lists[ this.state.id ]
    list.add( product )
    list.save()
    this.setState( { ok: this.state.ok + 1 } )
  }

  componentDidMount() {
    shop.events.authentified.add( this.loadSession )
    // this.loadSession()Top
  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  

  render() {
    let { locations, loading, noMoreOrders, orders,frachtkosten,topseller,productsById,count, modaleOpen, productSearch, productTempId } = this.state
    let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 100 )
    if ( !shop.session ) return <Redirect to={"/"}/>
    if ( !shop.session.value ) return <Redirect to={"/"}/>
    if ( !shop.session.value.extras ) return <Redirect to={"/"}/>
    //console.log("location",locations)
    const note = shop.config.showNote && shop.session.value.extras[ "ts-note" ]
    if(shop.session.value.extras){
      if(shop.session.value.extras.mainlink){
        if(!locations){
          locations = [];
        }
        if(locations.length == 0 && shop.session.value.extras.mainlink != 'yes'){
          locations[0] = [];
          locations[0].mapid = shop.session.value.extras.mainlink; 
          if(shop.session.value.extras.linkcountry){ locations[0].country = shop.session.value.country; }
          if(shop.session.value.extras.linkstreet){ locations[0].street = shop.session.value.street; }
          if(shop.session.value.extras.linktitle){ locations[0].name1 = shop.session.value.title; }
          if(shop.session.value.extras.linkpcode){ locations[0].pcode = shop.session.value.pcode; }
          if(shop.session.value.extras.linkcity){ locations[0].city = shop.session.value.city; }
        }
      }
    }

    const handleChangeSearchString = (event) => {
        //console.log("SEARCH CHANGE: ", event.target)
        this.setState({productSearch: []})
        for(let i = 0; i < this.state.topseller.length; i++){
            if(this.state.topseller[i].article_nr.includes(event.target.value) || this.state.topseller[i].article_nr.includes(event.target.value.toUpperCase()) ||
                this.state.topseller[i].desc.short_des.toUpperCase().includes(event.target.value.toUpperCase()) ||
                this.state.topseller[i].barcode.includes(event.target.value) ||
                (this.state.topseller[i].cats[0] && this.state.topseller[i].cats[0].cat_id && this.state.topseller[i].cats[0].cat_id.includes(event.target.value)) ||
                (this.state.topseller[i].extras && this.state.topseller[i].extras.category && this.state.topseller[i].extras.category.includes(event.target.value)) ||
                (shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" &&
                    this.state.topseller[i].extras && this.state.topseller[i].extras.rewe_nan && this.state.topseller[i].extras.rewe_nan.value.value.includes(event.target.value))) {
                this.setState(prevState => ({
                    productSearch: [...prevState.productSearch, this.state.topseller[i]]
                }));
                //console.log("RETURN SEARCH CHANGE CORRECT", this.state.products[i])
            }
        }
        this.setState({searchString: event.target.value})
      }; 
    const handleClearSearchString = () => {
        this.setState({productSearch: this.state.topseller, searchString: ""});
    }
    //console.log("topseller RENDER",topseller)

    {/*if (topseller && topseller.length > 0) {
      topseller.reverse();
    }*/}

    const panes = [
      { menuItem: 'Mein Konto', render: () => <TabPane>
        <MediaQuery minWidth={900}>
        <section className="pt2">
          <table className="w-100">
            <colgroup>
              <col width="30%"/>
              <col width="40%"/>
              <col width="30%"/>
            </colgroup>
            <thead style={{backgroundColor:""}}>
            <tr className="pt2 pb3  bb b--black-10 w-100">
              <th className="f4 pb3 tl">{translate( "Kundeninformation" )}</th>
              <th className="f4 pb3 tl">{translate( "Ihr Ansprechpartner" )}</th>
              <th className="f4 pb3 tl">{translate( "Passwort ändern" )}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td className="">
              <section className="pt4">
                <p className="f5">{shop.session.value.title} {shop.session.value.name1} {shop.session.value.name2} {shop.session.value.name3}<br/>
                {translate("Kundennummer: ")}{shop.session.value.map_id}<br/>
                {translate("E-Mail-Adresse: ")}{shop.session.value.email}<br/> {translate("Tel.Nr.: ")}{shop.session.value.phone}</p></section>
                <section className="mt4 pb4"></section>
              </td>
              <td>
                
              <section className="pb4">
        {shop.session.value.extras && shop.session.value.extras.verName && <div className={"pt2 pb4"}>
         
          <div className={"pa3 box-shadow ba bg-white mh-auto center ml0-ns "} style={{ maxWidth: "100%", width: "380px" }}>
            <div>
              <div className="flex flex-row-ns flex-column items-center">
                <div className="pr3-ns pb0-ns pb3 tc">
                  <Image
                    title={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    alt={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    className={"shadow-inset"}
                    width={210}
                    circular
                    src={`/image/${shop.session.value.extras.verName}.jpg`}/>
                </div>
                <div>
                  <div className={"b black"}>{shop.session.value.extras.verName}</div>
                  <div className={"pb2 nowrap f6 black-80"}> {shop.session.value.extras.verFunktion}</div>
                  {shop.session.value.extras.verPhone &&
                    <div className={""}><a href={`tel:${shop.session.value.extras.verPhone}`}>{shop.session.value.extras.verPhone}</a></div>}
                  {shop.session.value.extras.verMail && <div className={""}><a
                    href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Hüser van Zwoll, Kunde #${shop.session.value.map_id}`}>{shop.session.value.extras.verMail}</a>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>}
        {shop.session.value.extras.verMail && <Button className={"db w-100 w-auto-ns"} basic as={"a"}
                                                      href={`mailto:${shop.session.value.extras.verMail}?subject=Hüser van Zwoll, Kunde #${shop.session.value.map_id}`}><Icon
          name={"mail"}/> <span>{shop.session.value.extras.verMail}</span></Button>}
        {shop.session.value.extras.verPhone && <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`tel:${shop.session.value.extras.verPhone}`}><span><Icon
          name={"phone"}/> {shop.session.value.extras.verPhone}</span></Button>}
        {!process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={Link} to={"/form/customer_contact"}>{translate( "Kontaktformular" )}</Button>}
        {process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`mailto:${process.env.REACT_APP_SERVICE_EMAIL}`}>{translate( "Kontakt" )}</Button>}
      </section>

              </td>
              <td>
              <section className="pb4">

          <AccountReset email={shop.session.value.email}/>
        </section>
              </td>
              </tr>
            </tbody>
          </table>
          </section>
        
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
						<div className="cf pb2">
							<Message negative className="">
								<div className="total ">
									<div className="ph3">
										<Icon name="info" />{translate( "minimum order value not reached" )}
										<span className="pull-right">
                    						<Price>{shop.config.MIN_ORDER_VALUE}</Price>
								     </span>
									</div>
								</div>
								
							</Message>
						</div>
						}
        <section className="mt4 pb4">
          <div className="row-title title--left">
            <h2 className="title pb2">{translate( "Meine Produkte" )}</h2>
          </div>
          <div className="pb4 flex flex-row items-left justify-left">
          <FormInput
          Icon="search"
          style={{ }}
          className={""}
          value={this.state.searchString}
          onChange={handleChangeSearchString} icon="search" placeholder={translate( `Suche nach Artikelnummer oder Artikelbeschreibung` ) + " ..."}>
          </FormInput>
          <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
          <Icon name="close"></Icon>
          </Button>
          </div>
          <div className="pb3"> <Message neutral><p>{translate("Nach Möglichkeit bitten wir Sie, volle Kartons zu bestellen. Vielen Dank für Ihre Unterstützung.")} </p></Message> </div>
          <table className="w-100">
            <colgroup>
              <col width="7%"/>
              <col width="17%"/>
              <col width="12%"/>
              <col width="12%"/>
              <col width="8%"/>
              <col width="12%"/>
              <col width="10%"/>
              <col width="8%"/>
              <col width="12%"/>
            </colgroup>
            <thead>
            <tr className="pt2 pb3  bb b--black-30 w-100">
              <th className="f5 pb3 tl">&nbsp;</th>
              <th className="f5 pb3 tl">{translate( "Artikel" )}</th>
              <th className="f5 pb3 tc">{translate( "Zuletzt gekauft" )}</th>
              <th className="f5 pb3 tc">{translate( "Verfügbarkeit" )}</th>
              <th className="f5 pb3 tr">{translate( "Preis/VE" )}</th>
              <th className="f5 pb3 tc">{translate( "VE" )}</th>
              <th className="f5 pb3 tl">{translate( "Kartoninhalt" )}</th>
              <th className="f5 pb3 tr">&nbsp;</th>
              <th className="f5 pb3 tc">{translate( "Menge" )}</th>
              </tr>
            </thead>
            <tbody>
            <MyProductsOrderTable orders={orders} productSearch={productSearch} products={productSearch} baseUrl={baseUrl} count={count} modaleOpen={modaleOpen} onCloseModal={() => this.setState({modaleOpen: false})} handleChangeSearchString={handleChangeSearchString} handleClearSearchString={handleClearSearchString}/>
            </tbody>
            </table>
        </section>
          </MediaQuery>
        <MediaQuery maxWidth={899}>
          <section className="pt2 pb2">
            <div className="bb b--black-20">
              <h1 className="bb b--black-10 pb2 pt2">Kundeninformation</h1>
              <section className="pb3 f3 fw7"><p>
                {shop.session.value.title} {shop.session.value.name1} {shop.session.value.name2} {shop.session.value.name3}<br/>
                {translate("Kundennummer: ")}{shop.session.value.map_id}<br/>
                {translate("E-Mail-Adresse: ")}{shop.session.value.email}<br/> {translate("Tel.Nr.: ")}{shop.session.value.phone}</p></section>
            </div>
            <div className="bb b--black-20 pt4">
              <h1 className="bb b--black-10 pb2">Ihr Ansprechpartner</h1>
              <section className="pb4">
        {shop.session.value.extras && shop.session.value.extras.verName && <div className={"pt2 pb4"}>
          
          <div className={"pa3 box-shadow ba bg-white mh-auto center ml0-ns "} style={{ maxWidth: "100%", width: "100%" }}>
            <div>
              <div className="flex flex-row-ns flex-column items-center">
                <div className="pr3-ns pb0-ns pb3 tc">
                  <Image
                    title={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    alt={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    className={"shadow-inset"}
                    width={210}
                    circular
                    src={`/image/${shop.session.value.extras.verName}.jpg`}/>
                </div>
                <div>
                  <div className={"b black"}>{shop.session.value.extras.verName}</div>
                  <div className={"pb2 nowrap f6 black-80"}> {shop.session.value.extras.verFunktion}</div>
                  {shop.session.value.extras.verPhone &&
                    <div className={""}><a href={`tel:${shop.session.value.extras.verPhone}`}>{shop.session.value.extras.verPhone}</a></div>}
                  {shop.session.value.extras.verMail && <div className={""}><a
                    href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Hüser van Zwoll, Kunde #${shop.session.value.map_id}`}>{shop.session.value.extras.verMail}</a>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>}
        {shop.session.value.extras.verMail && <Button className={"db w-100 w-auto-ns"} style={{ maxWidth: "100%", width: "100%" }} basic as={"a"}
                                                      href={`mailto:${shop.session.value.extras.verMail}?subject=Hüser van Zwoll, Kunde #${shop.session.value.map_id}`}><Icon
          name={"mail"}/> <span>{shop.session.value.extras.verMail}</span></Button> }<br/>
        {shop.session.value.extras.verPhone && <Button style={{marginTop: "5px",maxWidth: "100%", width: "100%" }} className={"db w-100 w-auto-ns"} basic as={"a"} href={`tel:${shop.session.value.extras.verPhone}`}><span><Icon
          name={"phone"}/> {shop.session.value.extras.verPhone}</span></Button>}<br/>
        {!process.env.REACT_APP_SERVICE_EMAIL &&
          <Button style={{marginTop: "5px",maxWidth: "100%", width: "100%" }} className={"db w-100 w-auto-ns"} basic as={Link} to={"/form/customer_contact"}>{translate( "Kontaktformular" )}</Button>}
        {process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`mailto:${process.env.REACT_APP_SERVICE_EMAIL}`}>{translate( "Kontakt" )}</Button>}
      </section>
      </div>

      <div>
        <h1 className="bb b--black-10 pb2">Passwort ändern</h1>
        <section className="pb4">
          <AccountReset email={shop.session.value.email}/>
        </section>
      </div>
      <div>
        <h1 className="bb b--black-10 pb2">Meine Produkte</h1>
        <div className="pb4 flex flex-row items-left justify-left">
          <FormInput
          Icon="search"
          style={{ }}
          className={""}
          value={this.state.searchString}
          onChange={handleChangeSearchString} icon="search" placeholder={translate( `Suche nach Artikelnummer oder Artikelbeschreibung` ) + " ..."}>
          </FormInput>
          <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
          <Icon name="close"></Icon>
          </Button>
          </div>
          <div> <Message neutral><p>{translate("Nach Möglichkeit bitten wir Sie, volle Kartons zu bestellen. Vielen Dank für Ihre Unterstützung.")} </p></Message> </div>
<MyProductsOrderTable orders={orders} productSearch={productSearch} products={productSearch} baseUrl={baseUrl} count={count} modaleOpen={modaleOpen} onCloseModal={() => this.setState({modaleOpen: false})} handleChangeSearchString={handleChangeSearchString} handleClearSearchString={handleClearSearchString}/>
            
      </div>
          </section>
          </MediaQuery>

      </TabPane> },
      { menuItem: 'Meine Adressen', render: () => <TabPane>
        <div className="row-title tl">
          <h2>{translate( "Adressen" )}</h2>
        </div>
        
        <div className="pt3 pb3">
          <p>{translate( "accountpage.notice_temp_delivery_address" )}.</p>
        </div>

        <div className="ph2">
          <Card.Group itemsPerRow={3} doubling stackable>
            <Card md="1/5" className="">
              <Card.Header>
                <div className="pa3 b black-60">{translate( "Rechnungsadresse" )}</div>
              </Card.Header>
              <Card.Content>
                {shop.session.value.extras.mainlink && shop.session.value.extras.mainlink == 'yes' && <div className="">
                  <strong> {billingAddress.title}</strong> <br/>
                  {billingAddress.subtitle && <div>{billingAddress.subtitle}</div>}
                  {billingAddress.street} <br/>
                  {billingAddress.pcode} {billingAddress.city}<br/>
                  {billingAddress.country}<br/>
                </div>}
                {shop.session.value.extras.mainlink && shop.session.value.extras.mainlink != 'yes' && <div className="">
                  <strong> {shop.session.value.extras.linktitle}</strong> <br/>
                  {billingAddress.subtitle && <div></div>}
                  {shop.session.value.extras.linkstreet} <br/>
                  {shop.session.value.extras.linkpcode} {shop.session.value.extras.linkcity}<br/>
                  {shop.session.value.extras.linkcountry}<br/>
                </div>}
                {!shop.session.value.extras.mainlink && <div className="">
                  <strong> {shop.session.value.title}</strong> <br/>
                  {billingAddress.subtitle && <div></div>}
                  {shop.session.value.street} <br/>
                  {shop.session.value.pcode} {shop.session.value.city}<br/>
                  {shop.session.value.country}<br/>
                </div>}
              </Card.Content>
            </Card>
            {locationsOnDisplay}
          </Card.Group>
        </div>
        </TabPane> },
      { menuItem: 'Meine Bestellungen', render: () => <TabPane>
                <section className="mt4 pb5">
          <Row>
            <Col sm="1">
              <div className="row-title title--left">
                <h2 className="title">{translate( "Order History" )}</h2>
              </div>
              {orders.length >= 0 && <OrderTable orders={orders}/>}
              {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
              {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
              {!noMoreOrders && <div className="pa2 tc">
                <Button onClick={this.loadMore} loading={loading}>{translate("mehr laden")}</Button>
              </div>}
            </Col>
          </Row>
        </section>
        {console.log("shop.session ",shop.session, shop.session.handId, shop.session.canUseCartApi)}
        </TabPane> },
        ...(shop.session.handId && shop.session.handId !== "" ? [{ className: 'TabPane_Hvz', menuItem: 'Ansprechpartner', render: () => <TabPane>
                        <div className="row-title tl">
          <h2>{translate( "Ansprechpartner" )}</h2>
        </div>
                <section className=" pb5 pa2">
                  <Card.Group itemsPerRow={3} doubling stackable>
            {ansprechpartnerOnDisplay}
            </Card.Group>
        </section>
        </TabPane>}] : []),

    ]
    
    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      return (<Card key={key}
                    sm="1/5">
        <Card.Header>
          <div className="pa3 b black-60">{translate( "Lieferadresse" )}</div>
        </Card.Header>
        <Card.Content>
          <Address location={location}/>
        </Card.Content>
      </Card>)
    } )

    const extras = shop.session.value.extras || {}
    const ansprechpartnerRaw = extras["ansprechpartner"] || "[]"
    const ansprechpartner = (() => { try { return JSON.parse(ansprechpartnerRaw) } catch(e) { return [] } })()

    let ansprechpartnerOnDisplay = ansprechpartner.map( ( person, key ) => {
      return (<Card key={key} sm="1/5">
        <Card.Header>{console.log("person", person, shop.session)}
          <div className="pa3 b black-60">{person.anrede} {person.name}</div>
        </Card.Header>
        <Card.Content>
          {person.position   && <p className="f5 fw5">{"Position: "}{person.position}</p>}
          {person.telefon    && <p className="f5 fw5">{"Telefon: "}{person.telefon}</p>}
          {person.email      && <p className="f5 fw5">{"Email: "}{person.email}</p>}
          {person.handy      && <p className="f5 fw5">{"Handy: "}{person.handy}</p>}
          {person.bemerkung  && <p className="f5 fw5">{"Bemerkung: "}{htmr(person.bemerkung)}</p>}
        </Card.Content>
      </Card>)
    } )

    return (
      <div className="container pt4">
        <h1 className="page-title"><i className="icon-vcard icon-lg"/><strong>{translate( "My Account" )}</strong></h1>
        <p className="fw5 f3">{translate( "View your customer data and recent orders" )}</p>
        <Tab className="Tab_Hvz" panes={panes} />

        {/*<section>*/}
        {/*<div className="row-title tl">*/}
        {/*<h2>Mein Benutzer</h2>*/}
        {/*</div>*/}
        {/*</section>*/}

        {/*<section>*/}
        {/*<div className="row-title tl">*/}
        {/*<h2>Adressbuch</h2>*/}
        {/*</div>*/}
        {/*<Button onClick={() => { this.setState( { showAddressBook: true } )}}> Adressbuch öffnen </Button>*/}
        {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
        {/*</section>*/}


        {/*<section className="pt4">
        <div className="row-title title--left">
          <h2 className="title">{translate( "Budget" )}</h2>
        </div>
        <CostCentres/>
      </section>*/}



        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
    )
  }
}


class MyProductsOrderTable extends Component {

    state = {
      count: 1,
      modaleOpen: false,
    }

    loadProduct( id, productOld ) {

		this.id = id
		productStore.get( id )
			.then( product => {
				console.log( "ProductAcc::product", product )
				//product.count = this.state.count
				let inCart = shop.cart.productsById.get( product.map_id )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				 lastProducts = shop.analytics.lastProducts( 4 )
				  .filter( ( id ) => id !== product.map_id )
        product.count = productOld ? productOld.count : 1
				this.setState( {product: product, primaryImage: false} )
        console.log("product ADD",product, this.state.count)
        shop.cart.add( product )
        this.setState( { count: 1 } )
        shop.toast( `${product.count * product.unit_multi} Stück ${product.title} ${translate( "im Warenkorb" )}`, "info", false, "bottom" )
				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						//console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}
  
  render() {
    let { productSearch, products, baseUrl, modaleOpen, orders } = this.props
    //console.log("this.props", this.props)
    //console.log("this.state", this.state, this.props, orders)
    
    return <Fragment>

            <MediaQuery minWidth={900}>
                            {productSearch && productSearch.length > 0 && productSearch.map((product, index) => {
                let lastBought = null;
                let lastBoughtCount = 0;
                if (orders && orders.length > 0) {
                  orders.forEach(order => {
                    order.positions.forEach(position => {
                      if (position.article_id === product.map_id && (lastBought == null || moment(order.created).isAfter(lastBought))) {
                        lastBought = order.created
                        lastBoughtCount = position.count
                        //console.log("order", order, "lastBought", lastBought, "lastBoughtCount", lastBoughtCount, "position", position, "product.map_id", product.map_id)
                      }
                    })
                  })
                }
                return (
              <tr key={index} className="pt2 pb2 bb b--black-10">{console.log("product in map", product)}
                <td className="pt2 pb2 "><Link to={`/product/${product.map_id}`}><Image style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                 src={`${baseUrl}/shop/rest/data/images/description/${product.map_id}/1?size=small`} ></Image></Link></td>
                <td className="pt2 pb2 pr2"><Link to={`/product/${product.map_id}`}>
                  <strong>{product.article_nr}</strong> <br/>
                </Link>{product.desc.short_des}</td>
                <td className="tc"><div className="flex flex-column"><p>{lastBought ? moment(lastBought).format("DD.MM.YYYY") : "-"}</p> <p>{translate("Menge: ")} {lastBoughtCount > 0 ? lastBoughtCount : "-"}</p></div></td>
                <td className="pt2 pb2 tc">{console.log("PRODUCT:: ", product.extras.Einlagerung.value.value, product.stock)}
                  {product.extras && product.extras.stockText && product.extras.stockText.value.value ?
                   <Fragment><Icon title={"Auf Lager"} name="truck" color={product.extras.stockColor.value.value}/>{product.extras.stockText.value.value}{product.extras && product.extras.Einlagerung && product.extras.Einlagerung.value.value === "true" && <div> {product.stock} verfügbar</div>}</Fragment> :
                   <Fragment><Icon title={"Auf Lager"} name="truck" color={"green"}/><a>{"  Auf Lager"}</a>{product.extras && product.extras.Einlagerung && product.extras.Einlagerung.value.value === "true" && <span> {product.stock} verfügbar</span>}</Fragment>
                  }
                  </td>
                <td className="pt2 pb2 tc ">{product.extras.Preisanfrage.value.value !== "J" ? <Fragment>
                  <div className="flex flex-row items-end justify-end fw7 f5">
                                              <Price>{product.price.toFixed(2)}</Price></div>
                  {product.extras.Preisanfrage.value.value !== "J" &&<div className="flex flex-row items-end justify-end"> {/*flex flex-row items-center justify-center */}
                                      <table>
                                        <tbody>
                                        {/*shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.price && <tr className="tr" >
                                            <td className="f7">{translate("ab")}</td>
                                            <td className="f7 tr">1</td>
                                            <td className="f7 tr">{product.price.toFixed(2).replace(".",",")}€</td>
                                          </tr>*/}
                                       {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.prices && product.prices.length >= 1 && product.prices.map( price => (
                                          <tr className="tr" key={price.q}>
                                            <td className="f7 ">{translate("ab")}</td>
                                            <td className="f7 tr pr1 pl1">{price.q} </td>
                                            <td className="f7 tr">{price.p.toFixed(2).replace(".",",")}€</td>
                                          </tr>
                                        ) )}
                                        </tbody>
                                      </table>
                  </div>}</Fragment> : "" }</td>
                  <td className="tc">{product && product.quantities ? product.quantities[0].des : "-"}</td>
                  <td>{product && product.extras && product.extras["086"] ? product.extras["086"].value.value : "-"}</td>
                <td>
                  <p className="flex flex-column items-end justify-end">
                    {product.extras.Preisanfrage.value.value !== "J" && <p style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}>{Number(product.count * product.price).toFixed(2)} €</p>}
                    <p style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}>{product && product.quantities ? Number(product.quantities[0].multi * product.count).toFixed(0) : "-"} {product && product.quantities ? product.quantities[0].des : "-"}</p>
                  </p>
                </td>
                <td className=" pt2 pb2" style={{paddingLeft: "0", paddingRight: "0"}}>

                  <p className="flex flex-row items-end justify-end">
                  <MediaQuery minWidth={1200}>
                  <Input className="w-50" type="number" placeholder="1" disabled={product.extras.Preisanfrage.value.value !== "J" ? false : true} 
                value={product.count <= product.pinfos.minbuy ? product.pinfos.minbuy : product.count}
                min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} action 
                onChange={e => {
                  const mengenMulti = product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);
                  let newValue = e.target.value;
                  if(newValue.length > 1 && newValue.startsWith("0")){
                    newValue = newValue.replace(/^0+/, '');
                  }
                  //console.log("newValue",newValue, "mengenMulti", mengenMulti, product.extras.mengenMulti);
                  if (mengenMulti && mengenMulti > 0 && (newValue > mengenMulti)) {
                    //console.log("mengenMulti", mengenMulti);
                    const candidate = newValue - 1 + mengenMulti;
                    const candidate2 = Number(Number(newValue) + 1 - Number(mengenMulti));
                    //console.log("candidate", candidate, "candidate2", candidate2);
                    if (candidate % mengenMulti === 0) {
                      newValue = candidate;
                      //console.log("candidate is multiple of mengenMulti", candidate, "newValue", newValue);
                    }
                    else if (candidate2 % mengenMulti === 0) {
                      newValue = candidate2;
                    } else {
                      // If neither candidate is a multiple of mengenMulti, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                  }
                  
                  
                  // Only allow multiples of mengenMulti, and prevent manual entry of non-multiples
                  if (mengenMulti && mengenMulti > 0) {
                    // If the event is from arrow up/down, step the value by mengenMulti
                    //console.log("nativeEvent", e.nativeEvent);
                    if (e.nativeEvent.inputType === "insertText" || e.nativeEvent.inputType === "deleteContentBackward") {
                      // ignore manual typing, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                    // Only allow multiples of mengenMulti
                    let parsed = parseInt(newValue, 10);
                    if (isNaN(parsed) || parsed % mengenMulti !== 0) {
                      // Snap to nearest lower multiple
                      parsed = Math.floor(parsed / mengenMulti) * mengenMulti;
                      this.setState({ count: parsed });
                      return;
                    }
                  }
                  product.count = newValue
                  this.setState({ count: newValue });
                  //console.log("product.count", product.count, "newValue", newValue, "this.state.count", this.state.count);
						  }}
                onBlur={e => {
                  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
                  shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
                  e.target.value = Number(product.pinfos.minbuy);
                  this.setState({ count: e.target.value });
                    
                  }
                }}/>
                                {product.extras.Preisanfrage.value.value !== "J" ? <Button style={{width: "50px"}} primary onClick={( ) => {
                  //console.log("COUNT",this.state.count, product.pinfos.minbuy)
                                                if(this.state.count <= product.pinfos.minbuy){
                                                  this.setState({ count: product.pinfos.minbuy })
                                                  //shop.toast(translate(`Mindestbestellmenge wurde in den Warenkorb gelegt.`), "warning", false, "top");
                  
                                                }
                  console.log("ADD", product, this.state.count)
                  //shop.cart.add( product )
                  this.loadProduct( product.map_id, product )
                   }} ><Icon className="shopping cart"></Icon></Button> : 
                                      <div className="pl4"><Button style={{paddingLeft: "10px", maxWidth: "100px", maxHeight: "50px"}} fluid primary onClick={() => this.setState({modaleOpen: !this.state.modaleOpen})}>{translate( "Preis anfragen" )}  </Button>
                                      </div>}<ProductPriceInquiry product={product} modaleOpen={this.state.modaleOpen} onCloseModal={() => this.setState({modaleOpen: false})} />
                </MediaQuery>
                <MediaQuery maxWidth={1199}>
                  <p className="flex flex-column justify-center">

                            <Input  style={{width: "100px", paddingRight: "55px", paddingLeft: "5px"}} className="w-20 " type="number" placeholder="1" disabled={product.extras.Preisanfrage.value.value !== "J" ? false : true} 
              value={product.count <= product.pinfos.minbuy ? product.pinfos.minbuy : product.count}
                min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} action 
                onChange={e => {
                  const mengenMulti = product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);
                  let newValue = e.target.value;
                  if(newValue.length > 1 && newValue.startsWith("0")){
                    newValue = newValue.replace(/^0+/, '');
                  }
                  //console.log("newValue",newValue, "mengenMulti", mengenMulti, product.extras.mengenMulti);
                  if (mengenMulti && mengenMulti > 0 && (newValue > mengenMulti)) {
                    //console.log("mengenMulti", mengenMulti);
                    const candidate = newValue - 1 + mengenMulti;
                    const candidate2 = Number(Number(newValue) + 1 - Number(mengenMulti));
                    //console.log("candidate", candidate, "candidate2", candidate2);
                    if (candidate % mengenMulti === 0) {
                      newValue = candidate;
                      //console.log("candidate is multiple of mengenMulti", candidate, "newValue", newValue);
                    }
                    else if (candidate2 % mengenMulti === 0) {
                      newValue = candidate2;
                    } else {
                      // If neither candidate is a multiple of mengenMulti, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                  }
                  
                  
                  // Only allow multiples of mengenMulti, and prevent manual entry of non-multiples
                  if (mengenMulti && mengenMulti > 0) {
                    // If the event is from arrow up/down, step the value by mengenMulti
                    //console.log("nativeEvent", e.nativeEvent);
                    if (e.nativeEvent.inputType === "insertText" || e.nativeEvent.inputType === "deleteContentBackward") {
                      // ignore manual typing, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                    // Only allow multiples of mengenMulti
                    let parsed = parseInt(newValue, 10);
                    if (isNaN(parsed) || parsed % mengenMulti !== 0) {
                      // Snap to nearest lower multiple
                      parsed = Math.floor(parsed / mengenMulti) * mengenMulti;
                      this.setState({ count: parsed });
                      return;
                    }
                  }
                  product.count = newValue
                  this.setState({ count: newValue });
                  //console.log("product.count", product.count, "newValue", newValue, "this.state.count", this.state.count);
						  }}
                onBlur={e => {
                  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
                  shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
                  e.target.value = Number(product.pinfos.minbuy);
                  this.setState({ count: e.target.value });
                    
                  }
                }}>
                 <Button
                          size="tiny"
                          icon="minus"
                          onClick={() => {
                            console.log("newCount", newCount, "product.count", product.count, "mengenMulti", product.extras.mengenMulti);
                            let newCount = Number(product.count) - (product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value) || 1);
                            if(newCount < Number(product.pinfos.minbuy) || newCount < 1){
                              console.log("newCount", newCount, "product.pinfos.minbuy", product.pinfos.minbuy);
                              newCount = Number(product.pinfos.minbuy);
                              shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");

                            }

                            product.count = newCount;
                            this.setState({ count: newCount });
                          }} /> 
                <input type="number" value={product.count} min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} />
                        <Button
                          size="tiny"
                          icon="plus"
                          onClick={() => {
                            console.log("newCount", newCount, "product.count", product.count, "mengenMulti", product.extras.mengenMulti);
                            let newCount = Number(product.count) + (product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value) || 1);
                            

                            product.count = newCount;
                            this.setState({ count: newCount });
                          }} />  
                </Input>
                    <p style={{paddingTop: "5px", paddingLeft: "5px"}}>{product.extras.Preisanfrage.value.value !== "J" ? <Button style={{width: "105px"}} primary onClick={( ) => {
                  //console.log("COUNT",this.state.count, product.pinfos.minbuy)
                                                if(this.state.count <= product.pinfos.minbuy){
                                                  this.setState({ count: product.pinfos.minbuy })
                                                  //shop.toast(translate(`Mindestbestellmenge wurde in den Warenkorb gelegt.`), "warning", false, "top");
                  
                                                }
                  console.log("ADD", product, this.state.count)
                  //shop.cart.add( product )
                  this.loadProduct( product.map_id, product )
                   }} ><Icon className="shopping cart"></Icon></Button> : 
                                      <div className="pl4"><Button style={{paddingLeft: "10px", maxWidth: "100px", maxHeight: "50px"}} fluid primary onClick={() => this.setState({modaleOpen: !this.state.modaleOpen})}>{translate( "Preis anfragen" )}  </Button>
                                      </div>}<ProductPriceInquiry product={product} modaleOpen={this.state.modaleOpen} onCloseModal={() => this.setState({modaleOpen: false})} /></p>
                  </p>
                </MediaQuery>

                </p>
                </td>
              </tr>
                )
              })}
            </MediaQuery>
            <MediaQuery maxWidth={899}>
                      {productSearch && productSearch.length > 0 && productSearch.map((product, index) => {
                let lastBought = null;
                let lastBoughtCount = 0;
                if (orders && orders.length > 0) {
                  orders.forEach(order => {
                    order.positions.forEach(position => {
                      if (position.article_id === product.map_id && (lastBought == null || moment(order.created).isAfter(lastBought))) {
                        lastBought = order.created
                        lastBoughtCount = position.count
                        //console.log("order", order, "lastBought", lastBought, "lastBoughtCount", lastBoughtCount, "position", position, "product.map_id", product.map_id)
                      }
                    })
                  })
                }
                return (<section className="pb4" key={index}>
          <table className="mobileRespTable" >
          <colgroup>
            <col width="10%"/>
            <col width="90%"/>
            </colgroup>
          <tbody>
          <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
    <td className="tl pt2 pb2">
    <Link to={`/product/${product.map_id}`}><Image style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                 src={`${baseUrl}/shop/rest/data/images/description/${product.map_id}/1?size=small`} ></Image></Link></td>
                <td className="pr2 bb b--black-20 tr f5 fw7"><Link to={`/product/${product.map_id}`}>
                  <strong>{product.article_nr}</strong> <br/>
                  <strong>{product.desc.short_des}</strong>
                </Link>
        </td>
        <td>&nbsp;</td>
      </tr>
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Zuletzt gekauft:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr"><p className="pt1">{lastBought ? moment(lastBought).format("DD.MM.YYYY") : "-"}</p><p>{translate("Menge: ")} {lastBoughtCount > 0 ? lastBoughtCount : "-"}</p></span></td>
      </tr>
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Lieferbar:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr">
                          {product.extras && product.extras.stockText && product.extras.stockText.value.value ?
                   <Fragment><Icon title={"Auf Lager"} name="truck" color={product.extras.stockColor.value.value}/>{product.extras.stockText.value.value}{product.extras && product.extras.Einlagerung && product.extras.Einlagerung.value.value === "true" && <div> {product.stock} verfügbar</div>}</Fragment> :
                   <Fragment><Icon title={"Auf Lager"} name="truck" color={"green"}/><a>{"  Auf Lager"}</a>{product.extras && product.extras.Einlagerung && product.extras.Einlagerung.value.value === "true" && <span> {product.stock} verfügbar</span>}</Fragment>
                  
                  }</span></td>
      </tr>
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Preis/VE:" )} </td>
          <td className="pr2 bb b--black-20 tr f5 fw7">{product.extras.Preisanfrage.value.value !== "J" ? <Fragment>
    <div className="flex flex-row items-end justify-end fw7 f5">
                                <Price>{product.price.toFixed(2)}</Price></div>
    <div className="flex flex-row items-end justify-end"> {/*flex flex-row items-center justify-center */}
                        <table>
                          <tbody>
                          {/*shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.price && <tr className="tr" >
                              <td className="f7">{translate("ab")}</td>
                              <td className="f7 tr">1</td>
                              <td className="f7 tr">{product.price.toFixed(2).replace(".",",")}€</td>
                            </tr>*/}
                          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.prices && product.prices.length >= 1 && product.prices.map( price => (
                            <tr className="tr" key={price.q}>
                              <td className="f7 ">{translate("ab")}</td>
                              <td className="f7 tr pr1 pl1">{price.q} </td>
                              <td className="f7 tr">{price.p.toFixed(2).replace(".",",")}€</td>
                            </tr>
                          ) )}
                          </tbody>
                        </table>
    </div></Fragment> : "" }</td>
      </tr>}
      <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr">{product && product.quantities ? product.quantities[0].des : "-"}</span></td>
      </tr>
      <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Kartoninhalt:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr">{product && product.extras && product.extras["086"] ? product.extras["086"].value.value : "-"}</span></td>
      </tr>
      <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Summe:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">{product.extras.Preisanfrage.value.value !== "J" && <p className="f6 tr">{Number(product.count * product.price).toFixed(2)} €</p>}
        <p className="f6 tr">{product && product.quantities ? Number(product.quantities[0].multi * product.count).toFixed(0) : "-"} {product && product.quantities ? product.quantities[0].des : "-"}</p></td>
      </tr>
      <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Quantity(PU):" )} </td>
        <td  className="pr2 bb b--black-20 tr f5"><div className="flex flex-row justify-end ">{product.extras.Preisanfrage.value.value !== "J" &&
          <Input  style={{width: "100px"}} className="w-20" type="number" placeholder="1" disabled={product.extras.Preisanfrage.value.value !== "J" ? false : true} 
              value={product.count <= product.pinfos.minbuy ? product.pinfos.minbuy : product.count}
                min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} action 
                onChange={e => {
                  const mengenMulti = product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);
                  let newValue = e.target.value;
                  if(newValue.length > 1 && newValue.startsWith("0")){
                    newValue = newValue.replace(/^0+/, '');
                  }
                  //console.log("newValue",newValue, "mengenMulti", mengenMulti, product.extras.mengenMulti);
                  if (mengenMulti && mengenMulti > 0 && (newValue > mengenMulti)) {
                    //console.log("mengenMulti", mengenMulti);
                    const candidate = newValue - 1 + mengenMulti;
                    const candidate2 = Number(Number(newValue) + 1 - Number(mengenMulti));
                    //console.log("candidate", candidate, "candidate2", candidate2);
                    if (candidate % mengenMulti === 0) {
                      newValue = candidate;
                      //console.log("candidate is multiple of mengenMulti", candidate, "newValue", newValue);
                    }
                    else if (candidate2 % mengenMulti === 0) {
                      newValue = candidate2;
                    } else {
                      // If neither candidate is a multiple of mengenMulti, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                  }
                  
                  
                  // Only allow multiples of mengenMulti, and prevent manual entry of non-multiples
                  if (mengenMulti && mengenMulti > 0) {
                    // If the event is from arrow up/down, step the value by mengenMulti
                    //console.log("nativeEvent", e.nativeEvent);
                    if (e.nativeEvent.inputType === "insertText" || e.nativeEvent.inputType === "deleteContentBackward") {
                      // ignore manual typing, reset to last valid value
                      this.setState({ count: this.state.count });
                      return;
                    }
                    // Only allow multiples of mengenMulti
                    let parsed = parseInt(newValue, 10);
                    if (isNaN(parsed) || parsed % mengenMulti !== 0) {
                      // Snap to nearest lower multiple
                      parsed = Math.floor(parsed / mengenMulti) * mengenMulti;
                      this.setState({ count: parsed });
                      return;
                    }
                  }
                  product.count = newValue
                  this.setState({ count: newValue });
                  //console.log("product.count", product.count, "newValue", newValue, "this.state.count", this.state.count);
						  }}
                onBlur={e => {
                  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
                  shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
                  e.target.value = Number(product.pinfos.minbuy);
                  this.setState({ count: e.target.value });
                    
                  }
                }}>
                 <Button
                          size="tiny"
                          icon="minus"
                          onClick={() => {
                            console.log("newCount", newCount, "product.count", product.count, "mengenMulti", product.extras.mengenMulti);
                            let newCount = Number(product.count) - (product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value) || 1);
                            if(newCount < Number(product.pinfos.minbuy) || newCount < 1){
                              console.log("newCount", newCount, "product.pinfos.minbuy", product.pinfos.minbuy);
                              newCount = Number(product.pinfos.minbuy);
                              shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");

                            }

                            product.count = newCount;
                            this.setState({ count: newCount });
                          }} /> 
                <input type="number" value={product.count} min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} />
                        <Button
                          size="tiny"
                          icon="plus"
                          onClick={() => {
                            console.log("newCount", newCount, "product.count", product.count, "mengenMulti", product.extras.mengenMulti);
                            let newCount = Number(product.count) + (product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value) || 1);
                            

                            product.count = newCount;
                            this.setState({ count: newCount });
                          }} />  
                </Input>}
                <div style={{paddingLeft: "75px"}}>
                {product.extras.Preisanfrage.value.value !== "J" ? <Button primary onClick={( ) => {
                              
                              if(this.state.count <= product.pinfos.minbuy){
                                this.setState({ count: product.pinfos.minbuy })
                                //shop.toast(translate(`Mindestbestellmenge wurde in den Warenkorb gelegt.`), "warning", false, "top");

                              }
                              console.log("ADD", product)
                              this.loadProduct( product.map_id, product )
                               }} ><Icon className="shopping cart"></Icon></Button> :
                                                  <Button  fluid primary onClick={() => this.setState({modaleOpen: !this.state.modaleOpen})}>{translate( "Preis anfragen" )}  </Button>
                                                  }<ProductPriceInquiry product={product} modaleOpen={this.state.modaleOpen} onCloseModal={() => this.setState({modaleOpen: false})} />
                                                  </div>
                                                  </div></td>
      </tr>
          </tbody>
        </table>
      </section>)})}
            </MediaQuery>
            </Fragment>
            
          }
  }

const OrderTable = ( { orders } ) => {
  if ( orders.length === 0 ) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
    <Fragment>
    <MediaQuery minWidth={900}>
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="50%"/>
          <col width="15%"/>
          <col width="10%"/>
          <col width="10%"/>
        </colgroup>

        <tbody>
        <tr>
          <th className="ttu">{translate( "order number" )}</th>
          <th className="ttu tl">{translate( "price" )}</th>
          <th className="ttu tc">{translate( "positions" )}</th>
          <th className="ttu tc">{translate( "date" )}</th>
        </tr>

        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow key={order.id} order={order}/> )}
        </tbody>
      </Table>
    </div>
    </MediaQuery>
    <MediaQuery maxWidth={899}>
    <div className="table-scroller">
      <table className="mobileRespTable" >
        <colgroup>
          <col width="20%"/>
          <col width="80%"/>
          </colgroup>
        <tbody>
        {orders.length > 0 && orders.map( ( order ) =>
           <Fragment key={order.id} order={order}>
        <tr className={`ProductRowDefReturnMobile step `}>
          <td className="pl2  fw7 f5">{translate( "order number" )}</td>
          <td  className="pr2 bb b--black-20 tr f5 fw7">
            <Link to={`/account/orders/${order.map_id}`}>
              #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
            </Link>
            </td>
           </tr>
           <tr className={`ProductRowDefReturnMobile step `}>
            <td className="pl2  fw7 f5">{translate( "price" )}</td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
              <Price>{order.netto}</Price>
            </td>
           </tr>
           <tr className={`ProductRowDefReturnMobile step `}>
          <td className="pl2  fw7 f5">{translate( "positions" )}</td>
          <td  className="pr2 bb b--black-20 tr f5 fw7">
          {order.positions.length}
            </td>
           </tr>
           <tr className={` ProductRowDefReturnMobileRight step`}>
          <td className="pl2  fw7 f5">{translate( "date" )}</td>
          <td  className="pr2 bb b--black-20 tr f5 fw7">
          {moment( order.register ).format( "DD.MM.YYYY" )}
            </td>
           </tr>
        </Fragment> )}
        </tbody>
      </table>
    </div>
    </MediaQuery>
    </Fragment>
  )
}

const OrderPreviewRow = ( { order } ) => {
  const orderDate = moment( order.register )
    .format( "DD.MM.YYYY" )
  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === "2" || order.status === 2)
  let orderstateCounter = 0
  let orderstate = 0
  let orderstateArray = ["Vollständig geliefert","Rückstand","Teilweise geliefert"];
  
  for(let i = 0; order.positions.length > i; i++){
    
    /*if(order.positions[i].open != 0 && orderstate != 2){
      orderstate = 1
    }
    if(orderstate == 1 && order.positions[i].open == 0){
      orderstate = 2
    }*/
    if(order.positions[i].open != 0){
      orderstateCounter++
    }
    
    //console.log("order: ",order.map_id,"open: " ,order.positions[i].open," orderstate ",orderstate)
  }
  console.log("orderstatecounter: ", orderstateCounter, " order.length: ", order.positions.length)
  if(orderstateCounter == order.positions.length){
    orderstate = 1
  }
  if(orderstateCounter < order.positions.length){
    orderstate = 2
  }
  if(orderstateCounter == 0){
    orderstate = 0
  }

  var counterLieferschein = 0
  var counterRechnung = 0
  var counterAuftrag = 0
  order.extrainfo.map((answer, i) => {     
    if(answer.content && answer.content.includes("VKSF")){
     
     counterRechnung++
    } })
    
    order.extrainfo.map((answer, i) => {     
           
      if(answer.content && answer.content.includes("VKLS")){
        counterLieferschein++
      }
   })
  return (
    <tr>
      <td>
        <Link to={orderLink}>
          #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
        </Link>
      </td>
      <td className="tr"><Price>{order.netto}</Price></td>
      <td className="tc">{order.positions.length}</td>
      <td className="tc">
        <div className="nowrap">{orderDate}</div>
      </td>
      <td className="tc">
        <div className="flex flex-row items-center">
        {/*<td className="tc">{isSuccess ? <i className="icon-ok"></i> : <i className="icon-cancel"></i>}{translate(orderstateArray[orderstate])}</td>*/}
        </div>
      </td>
    </tr>
  )
}

const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (
    <React.Fragment>
      <div className="address-block pb3">
        <div className=""><strong>{location.name1} {location.name2} {location.name3}</strong></div>
        <div className="block"><strong>{location.company || <span className="black-40">&hellip;</span>}</strong>
          <br/>
          {location.street || <span className="black-40">&hellip;</span>}<br/>
          {location.pcode} {location.city || <span className="black-40">&hellip;</span>}<br/>
          {location.country || <span className="black-40">&hellip;</span>}<br/>
          {location.extras && location.extras.bemerkung && location.extras.bemerkung != '' && <div>Bemerkung: {htmr(location.extras.bemerkung)} </div> }
        </div>
        <div className="pt3">
          {/*<a onClick={() => {shop.cart.setAddress( { location } )}} className="black-40" href="#">als Lieferadresse</a> <br/>*/}
          {/*<a className="black-40" href="#">Änderung beantragen</a> <br/>*/}
          {/*<a className="black-40" href="#">löschen</a> <br/>*/}
        </div>
      </div>
    </React.Fragment>
  )
}

@observer
class List extends Component {
  constructor( props ) {
    super( props )
    let { list } = props
    
    this.state = {
      list
    }
    
  }
  
  
  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.handleListChange )
  }
  
  render() {
    let { list, onChange } = this.props
    console.log("LIST",list)  
    return <div className="cf">
      <ProductTableProducts key={list.hash} onChange={onChange} list={list}/>
      {/*<CartTotal list={list}/>*/}
      <br/>
    </div>
  }
}

const getProducts = () => shop.cart.map( ( product ) => product)

const TemporaryAddress = ( { onSubmit, temporaryAddress } ) => {
  const [open, setOpen] = React.useState( false )
  const [untouched, setUntouched] = React.useState( true )
  const [address, setAddress] = React.useState( false )
  return <div>
    <Button onClick={() => setOpen( true )}>{translate( "Neue Lieferadresse" )}</Button>
    <Modal open={open}>
      <Modal.Header>
        <div className="flex flex-row justify-between items-center">
          <div>{translate( "Lieferadresse" )}</div>
          <Button basic circular
                  onClick={() => {
                    setOpen( false )
                  }}
                  icon="times"
          />
        </div>
      
      </Modal.Header>
      <Modal.Content>
        <TemporaryAddressForm
          untouched={untouched}
          onChange={( address ) => {
            setAddress( address )
          }}/>
      </Modal.Content>
      <Modal.Actions>
        <Button basic type="link-cancel" onClick={() => setOpen( false )}>{translate( "schließen" )}</Button>
        <Button primary className="fr" onClick={() => {
          setUntouched( false )
          if ( !address.name1 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmen" ) )
          // if ( !address.name2 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmenszusatz" ) )
          if ( !address.street ) return shop.toast( translate( "Bitte ausfüllen: Straße" ) )
          if ( !address.city ) return shop.toast( translate( "Bitte ausfüllen: Stadt" ) )
          if ( !address.pcode ) return shop.toast( translate( "Bitte ausfüllen: Postleitzahl" ) )
          onSubmit( address )
          // TODO: VALIDATE
          setOpen( false )
        }
        } type="primary">{translate( "Adresse auswählen" )}</Button>
      </Modal.Actions>
    </Modal>
  </div>
  
  // return (
  //   <div>
  //     <Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
  //       <ModalHeader text={`Neue Adresse hinzufügen`} onClose={() => handleModal( false )}/>
  //       <ModalBody>
  //         <TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress}/>
  //       </ModalBody>
  //       <ModalFooter>
  //         <Button type="link-cancel" onClick={() => handleModal( false )}>schließen</Button>
  //         <Button className="fr" type="primary" onClick={() => handleAddressChoice()}>hinzufügen</Button>
  //       </ModalFooter>
  //     </Modal>
  //
  //     <Row>
  //       <Col sm="1">
  //         <Button className="mt2" onClick={() => handleModal( true )}>temporäre Adresse hinzufügen</Button>
  //       </Col>
  //     </Row>
  //   </div>
  // )
}

const TemporaryAddressForm = ( { onChange, untouched = true, temporaryAddress = {} } ) => {
  const [form, setForm] = React.useState( Object.assign( { extras: { freecontact: "",ILN: "" } }, temporaryAddress ) )
  const handleChange = ( event ) => {
    const name = event.currentTarget.name
    const value = event.currentTarget.value
    const newForm = { ...form, [ name ]: value }
    setForm( newForm )
    onChange && onChange( newForm )
  }
  const handleGLNChange = ( event ) => {
    let glnID = event.target.value
    this.setState( { glnID } )
    shop.cart.setExtra( "glnID", glnID )
  }
  
  return (
    <form className={`AddressForm TemporaryAddressForm ${untouched ? "untouched" : ""}`}>
      <Row>
        <Col sm="1/3">
          <FormField label={translate( "Unternehmen" ) + "*"} htmlFor="name1">
            <FormInput maxLength={50} required type="text" name="name1" value={form.name1} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Unternehmenszusatz" )} htmlFor="name2">
            <FormInput maxLength={50} type="text" name="name2" value={form.name2} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Ansprechpartner" )} htmlFor="contact">
            <FormInput maxLength={50} type="text" name="freecontact" value={form.extras.freecontact} onChange={( event ) => {
              const name = event.currentTarget.name
              const value = event.currentTarget.value
              const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
              setForm( newForm )
              onChange && onChange( newForm )
              console.log( { newForm } )
            }}/>
          </FormField>
        </Col>
      
      </Row>
      {/*<FormField label="Firma" htmlFor="company">*/}
      {/*  <Row>*/}
      {/*    <Col sm="1">*/}
      {/*      <FormInput type="text" name="company" placeholder="Firma" value={form.company}*/}
      {/*                 onChange={handleChange}/>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</FormField>*/}
      
      <Row>
        <Col sm="1">
          <FormField required label={translate( "Straße" ) + "*"} htmlFor="street">
            <FormInput required maxLength={50} type="text" name="street" placeholder="Straße" value={form.street}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1">
          <FormField label={translate( "Adresszusatz" )} htmlFor="addition">
            <FormInput maxLength={50} type="text" name="addition" placeholder="Adresszusatz"
                       value={form.addition}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1/5">
          <FormField maxLength={20} required label={translate( "PLZ" ) + "*"} htmlFor="pcode">
            <FormInput required type="text" name="pcode" placeholder="PLZ" value={form.pcode}
                       onChange={handleChange}/>
          </FormField>
        </Col>
        <Col sm="4/5">
          <FormField required label={translate( "Ort" ) + "*"} htmlFor="city">
            <FormInput required maxLength={30} type="text" name="city" placeholder={translate("Ort")} value={form.city}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <FormField label="Land" htmlFor="country">
        <Row>
          <Col sm="1">
            <Dropdown
              placeholder="Land"
              fluid
              search
              selection
              options={countryOptions}
              onChange={( e, { value } ) => {
                console.log( { value } )
                let fakeEvent = { currentTarget: { name: "country", value } }
                handleChange( fakeEvent )
              }}
            />
          
          </Col>
        </Row>
      </FormField>
      
      <div className="pt3">
        <p className="f6 black-80">{translate( "Für Rückfragen des Lieferdienstes" )}:</p>
        
        <Row>
          <Col sm="1/5">
            <FormField label="E-Mail" htmlFor="email">
              <FormInput maxLength={50} type="email" name="email" placeholder="E-Mail" value={form.email}
                         onChange={handleChange}/>
            </FormField>
          </Col>
          <Col sm="2/5">
            <FormField label="Telefon" htmlFor="phone">
              <FormInput maxLength={30} type="text" name="phone" placeholder="+49..." value={form.phone}
                         onChange={handleChange}/>
            </FormField>
          </Col>
          <Col sm="2/5">
            <FormField label="GLN" htmlFor="ILN">
              <FormInput maxLength={50} type="text" name="ILN" value={form.extras.ILN} onChange={( event ) => {
                const name = event.currentTarget.name
                const value = event.currentTarget.value
                const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
                setForm( newForm )
                onChange && onChange( newForm )
                console.log( { newForm } )
              }}/>
            </FormField>
          </Col>
        </Row>
      </div>
    </form>
  )
}


const countryOptions = [
  ["DE", "Deutschland"],
].map( e => ({ key: e[ 0 ], value: e[ 0 ], text: e[ 1 ], flag: e[ 0 ].toLowerCase() }) )


// WEBPACK FOOTER //
// ./src/theme/hvz/pages/AccountPage.js